"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/styles");
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Fonts = require("../constants/Fonts");
var _pittaModules = require("@thingsw/pitta-modules");
var _core = require("@material-ui/core");
var _excluded = ["variant", "children", "disabled", "loading", "color", "startIcon", "endIcon"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return (0, _core.createStyles)({
    //@ts-ignore
    root: _objectSpread({
      textTransform: "none",
      padding: "8px 16px",
      minHeight: 36,
      minWidth: 96,
      // UXUI 둥근디자인으로 전체 적용(LEEHJ) -> 10로 다시 변경됨(mckim)
      borderRadius: 10
    }, _Fonts.Fonts.Default.Button),
    // containedPrimary: {
    //   "&:focus": {
    //     backgroundColor: LightColors.primary["8"],
    //   },
    // },
    outlined: {
      minHeight: 36,
      padding: "7px 16px",
      backgroundColor: function backgroundColor(props) {
        switch (props.color) {
          case "gray-check":
            return _pittaModules.LightColors.primary["3"];
          case "gray-dark":
            return _pittaModules.DarkColors.primary["5"];
          case "black-dark":
            return _pittaModules.DarkColors.primary["0"];
          default:
            return _pittaModules.LightColors.primary["0"];
        }
      },
      color: function color(props) {
        switch (props.color) {
          case "primary":
            return _pittaModules.LightColors.primary["1"];
          case "secondary":
            return _pittaModules.LightColors.secondary["11"];
          case "gray":
            return _pittaModules.LightColors.primary["2"];
          case "gray-check":
            return _pittaModules.LightColors.primary["0"];
          case "gray-dark":
            return _pittaModules.DarkColors.primary["1"];
          case "black-dark":
            return _pittaModules.DarkColors.primary["2"];
        }
      },
      borderColor: function borderColor(props) {
        switch (props.color) {
          case "gray-dark":
            return _pittaModules.LightColors.primary["2"];
          case "black-dark":
            return _pittaModules.DarkColors.primary["2"];
          default:
            return _pittaModules.LightColors.primary["4"];
        }
      },
      "&:hover": {
        backgroundColor: function backgroundColor(props) {
          switch (props.color) {
            case "gray-check":
              return _pittaModules.LightColors.primary["3"];
            case "gray-dark":
              return _pittaModules.DarkColors.primary["5"];
            case "black-dark":
              return _pittaModules.DarkColors.primary["0"];
            default:
              return _pittaModules.LightColors.primary["0"];
          }
        },
        borderColor: function borderColor(props) {
          switch (props.color) {
            case "gray-dark":
              return _pittaModules.LightColors.primary["2"];
            case "black-dark":
              return _pittaModules.DarkColors.primary["2"];
            default:
              return _pittaModules.LightColors.primary["4"];
          }
        },
        color: function color(props) {
          switch (props.color) {
            case "primary":
              return _pittaModules.LightColors.primary["7"];
            case "secondary":
              return _pittaModules.LightColors.secondary["11"];
            case "gray":
              return _pittaModules.LightColors.primary["2"];
            case "gray-check":
              return _pittaModules.LightColors.primary["0"];
            case "gray-dark":
              return _pittaModules.DarkColors.primary["1"];
            case "black-dark":
              return _pittaModules.DarkColors.primary["2"];
          }
        }
      },
      "&:active": {
        backgroundColor: function backgroundColor(props) {
          switch (props.color) {
            case "primary":
              return _pittaModules.LightColors.primary["10"];
            case "secondary":
              return _pittaModules.LightColors.secondary["14"];
            case "gray":
              return _pittaModules.LightColors.primary["6"];
            case "gray-check":
              return _pittaModules.LightColors.primary["2"];
            case "gray-dark":
              return _pittaModules.DarkColors.primary["5"];
          }
        },
        color: function color(props) {
          switch (props.color) {
            case "primary":
              return _pittaModules.LightColors.primary["7"];
            case "secondary":
              return _pittaModules.LightColors.secondary["11"];
            case "gray":
              return _pittaModules.LightColors.primary["2"];
            case "gray-dark":
              return _pittaModules.DarkColors.primary["0"];
          }
        }
      },
      "&.Mui-disabled": {
        color: function color(props) {
          switch (props.color) {
            default:
              return "".concat(_pittaModules.LightColors.primary["1"], "59");
          }
        },
        backgroundColor: function backgroundColor(props) {
          switch (props.color) {
            case "gray-dark":
              return _pittaModules.DarkColors.primary["5"] + " !important";
          }
        },
        borderColor: "".concat(_pittaModules.LightColors.primary["4"], "59")
      }
    },
    text: {
      minHeight: 36,
      padding: "7px 16px",
      backgroundColor: _pittaModules.LightColors.primary["0"],
      color: function color(props) {
        switch (props.color) {
          case "gray":
            return _pittaModules.LightColors.primary["2"];
          case "secondary":
            return _pittaModules.LightColors.secondary["11"];
          default:
            return _pittaModules.LightColors.primary["7"];
        }
      },
      "&:hover": {
        color: function color(props) {
          switch (props.color) {
            case "gray":
              return _pittaModules.LightColors.primary["2"];
            case "secondary":
              return _pittaModules.LightColors.secondary["11"];
            default:
              return _pittaModules.LightColors.primary["7"];
          }
        }
      },
      "&.Mui-disabled": {
        color: function color(props) {
          return props.color === "primary" ? "".concat(_pittaModules.LightColors.primary["7"], "59") : "".concat(_pittaModules.LightColors.secondary["11"], "59");
        }
      }
    },
    contained: {
      border: function border(props) {
        switch (props.color) {
          case "default":
            return "1px solid ".concat(_pittaModules.LightColors.primary["0"]);
        }
      },
      backgroundColor: function backgroundColor(props) {
        switch (props.color) {
          case "default":
            return "#8E8E8E";
        }
      },
      color: function color(props) {
        switch (props.color) {
          case "default":
            return _pittaModules.LightColors.primary["0"];
        }
      },
      "&.Mui-focusVisible": {
        backgroundColor: function backgroundColor(props) {
          return props.color === "primary" ? _pittaModules.LightColors.primary["8"] : _pittaModules.LightColors.secondary["12"];
        },
        "&>.MuiTouchRipple-root": {
          display: "none"
        }
      },
      "&.Mui-disabled": {
        backgroundColor: function backgroundColor(props) {
          return props.color === "primary" ? "".concat(_pittaModules.LightColors.primary["7"], "59") : "".concat(_pittaModules.LightColors.secondary["11"], "59");
        },
        color: _pittaModules.LightColors.primary["0"]
      },
      "&:active": {
        backgroundColor: function backgroundColor(props) {
          switch (props.color) {
            case "primary":
              return _pittaModules.LightColors.primary["7"];
            case "secondary":
              return _pittaModules.LightColors.secondary["11"];
            case "default":
              return "#8E8E8E";
          }
        }
      }
    },
    //@ts-ignore
    sizeLarge: _objectSpread({
      minHeight: 48
    }, _Fonts.Fonts.Large.H6),
    startIcon: theme.direction === "rtl" ? {
      marginLeft: function marginLeft(props) {
        return props.children ? theme.spacing(1) : 0;
      },
      marginRight: function marginRight(props) {
        return props.children ? -theme.spacing(0.5) : 0;
      }
    } : {
      marginRight: function marginRight(props) {
        return props.children ? theme.spacing(1) : 0;
      },
      marginLeft: function marginLeft(props) {
        return props.children ? -theme.spacing(0.5) : 0;
      }
    }
    //   label: { ...Fonts.Button },
  });
});

var Button = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var theme = (0, _styles.useTheme)();
  var classes = useStyle(props);
  var variant = props.variant,
    children = props.children,
    disabled = props.disabled,
    loading = props.loading,
    color = props.color,
    startIcon = props.startIcon,
    endIcon = props.endIcon,
    restProps = _objectWithoutProperties(props, _excluded);
  var circularColor = (0, _react.useMemo)(function () {
    if (color === "default" || color === "gray" || color === "gray-check" || color === "gray-dark" || color === "black-dark") {
      return undefined;
    }
    return color;
  }, [color]);
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    dir: theme.direction,
    classes: classes
  }, restProps, {
    startIcon: loading || startIcon,
    endIcon: loading || endIcon,
    color: circularColor,
    variant: variant || "contained",
    disableElevation: true,
    disabled: disabled || loading,
    disableFocusRipple: true,
    disableRipple: true,
    ref: ref
  }), loading ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 20,
    thickness: 6,
    color: circularColor
  }) : children);
});
exports.Button = Button;